import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import type { Bet, BetRecommendation } from '../../types';
import { BetCard } from './BetCard';

interface FullAnalysisModalProps {
  recommendation: BetRecommendation;
  existingBet?: Bet;
  onClose: () => void;
}

/**
 * Tier 3: Full-analysis modal wrapping the existing BetCard.
 * Accessible via "View Full Analysis" on the AdvisorDecisionCard.
 */
export function FullAnalysisModal({ recommendation, existingBet, onClose }: FullAnalysisModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto py-8 px-4">
      {/* Backdrop */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/70"
        onClick={onClose}
      />

      {/* Panel */}
      <motion.div
        initial={{ opacity: 0, scale: 0.97, y: 8 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.97 }}
        transition={{ duration: 0.18 }}
        className="relative w-full max-w-xl z-10"
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-20 bg-surface-2 border border-surface-4 rounded-full p-1.5 text-gray-400 hover:text-gray-200 transition-colors shadow-lg"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="text-xs text-gray-500 mb-2 ml-1 uppercase tracking-widest font-medium">
          Full Analysis
        </div>

        <BetCard recommendation={recommendation} existingBet={existingBet} />
      </motion.div>
    </div>
  );
}
